import {
  FACTORY,
  FULL_SERVICE,
  GLOBAL_CATALOGS,
} from '../../types';

const initialState = {
  tabs: [],
  isLoading: false,
  value: GLOBAL_CATALOGS.Catering.Announcement.List,
  announcement: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  report: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  introduction: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  // 一卡通消費記錄
  consumption: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  factory: {
    list: []
  },
  details: {},

};

const cateringReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_SERVICE.Catering.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_SERVICE.Catering.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case GLOBAL_CATALOGS.Catering.Service: {
      return {
        ...state,
        tabs: action.payload
      };
    }
    case GLOBAL_CATALOGS.Catering.Announcement.List: {
      return {
        ...state,
        announcement: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Catering.Report.List: {
      return {
        ...state,
        report: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Catering.Introduction.List: {
      return {
        ...state,
        introduction: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Catering.Consumption.List: {
      return {
        ...state,
        consumption: { ...action.payload }
      };
    }
    case FACTORY.SmartCard.List: {
      return {
        ...state,
        factory: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default cateringReducer;
